import React from "react";

const Expired = () => {
  return <div>Expired</div>;
};

export default Expired;
